export default __webpack_public_path__ + "static/media/githubIcon.4eea5c76.svg";